var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoach = function SvgCoach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.906 30.667v-4.873l7.91-10.249.03-.038a1.92 1.92 0 0 0-3.05-2.334l-4.498 5.724a3.18 3.18 0 0 1-2.503 1.218H5.227a3.84 3.84 0 0 0-3.84 3.84v4.482a1.92 1.92 0 0 0 3.84 0v-3.842m-.023 3.781v2.29m7.44-24.202v-5.13h16.638V16.64h-5.058M16.535 6.434l2.646 1.842L23.64 6.28l1.85 2.707M11.314 1.334h19.3m-25.41 11.98a3.328 3.328 0 1 0 6.655-.001 3.328 3.328 0 0 0-6.655 0",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgCoach;